import { Icon } from './_Icon';
export const QuizIcon = (props) => (
  <Icon
    {...props}
    d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0z M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3 M12 17h.01"
  />
);
